// autogenerated - do not edit

const beige = { base: '#faf5f0' };

const blue = {
  base: '#34b5d5',
  darken1: '#2991ae',
  darken2: '#257793',
  darken3: '#24627a',
  darken4: '#245265',
  lighten1: '#62c2da',
  lighten2: '#92d2e2',
  lighten3: '#c4e9f3',
  lighten4: '#d6eff5',
  lighten5: '#eaf7fb',
  lighten6: '#f3f9fb',
};

const brown = {
  base: '#b98c5f',
  darken1: '#aa7846',
  darken2: '#906337',
  darken3: '#764f28',
  darken4: '#5e4731',
  lighten1: '#be936a',
  lighten2: '#c9a583',
  lighten3: '#d3b99c',
  lighten4: '#e1cfbc',
  lighten5: '#eee3d8',
  lighten6: '#f4f0eb',
};

const dashboard = {
  blue: '#62c2da',
  green: '#60c396',
  orange: '#e6854c',
  pink: '#e26a92',
  purple: '#a28dd8',
  red: '#e7766a',
  slate: '#62a3e4',
  yellow: '#eebd49',
};

const green = {
  base: '#46aa7d',
  darken1: '#328560',
  darken2: '#2b694d',
  darken3: '#26543f',
  darken4: '#214535',
  lighten1: '#60c396',
  lighten2: '#7dcaa7',
  lighten3: '#9adbbd',
  lighten4: '#d2efe1',
  lighten5: '#e4f6ee',
  lighten6: '#f4fbf8',
};

const grey = {
  base: 'rgba(56, 54, 48, .6)',
  darken1: 'rgba(56, 54, 48, .7)',
  darken2: 'rgba(56, 54, 48, .8)',
  darken3: 'rgba(56, 54, 48, .9)',
  darken4: 'rgba(56, 54, 48, 1)',
  lighten1: 'rgba(56, 54, 48, .4)',
  lighten2: 'rgba(56, 54, 48, .3)',
  lighten3: 'rgba(56, 54, 48, .16)',
  lighten4: 'rgba(56, 54, 48, .09)',
  lighten5: 'rgba(56, 54, 48, .08)',
  lighten6: 'rgba(56, 54, 48, .06)',
  lighten7: 'rgba(56, 54, 48, .04)',
  lighten8: 'rgba(56, 54, 48, .02)',
};

const orange = {
  base: '#e58852',
  darken1: '#e1692d',
  darken2: '#ab3f21',
  darken3: '#8d3220',
  darken4: '#722d1d',
  lighten1: '#e6854c',
  lighten2: '#e89768',
  lighten3: '#ecb183',
  lighten4: '#f8d9bf',
  lighten5: '#faebdb',
  lighten6: '#fcf5ed',
};

const pink = {
  base: '#da587f',
  darken1: '#c93b5e',
  darken2: '#ac2a46',
  darken3: '#8e253a',
  darken4: '#772233',
  lighten1: '#e26a92',
  lighten2: '#e788a8',
  lighten3: '#f0b2c8',
  lighten4: '#f6d5e1',
  lighten5: '#faeaf1',
  lighten6: '#fcf3f6',
};

const purple = {
  base: '#927dca',
  darken1: '#7e5eba',
  darken2: '#7553ac',
  darken3: '#614691',
  darken4: '#513b78',
  lighten1: '#a28dd8',
  lighten2: '#b09fdb',
  lighten3: '#c5b9e4',
  lighten4: '#e0daf1',
  lighten5: '#ece8f7',
  lighten6: '#f5f4fa',
};

const red = {
  base: '#dc5647',
  darken1: '#cd4637',
  darken2: '#ab382b',
  darken3: '#8d3025',
  darken4: '#792e25',
  lighten1: '#e7766a',
  lighten2: '#ed968c',
  lighten3: '#f3b6af',
  lighten4: '#f8d1ce',
  lighten5: '#fbe7e4',
  lighten6: '#fcf4f2',
};

const shades = {
  black: '#000000',
  transparent: 'transparent',
  white: '#ffffff',
};

const slate = {
  base: '#5690dc',
  darken1: '#3e74d0',
  darken2: '#3561c0',
  darken3: '#304f9c',
  darken4: '#2a457e',
  lighten1: '#62a3e4',
  lighten2: '#84b5e7',
  lighten3: '#a0caee',
  lighten4: '#c6ddf5',
  lighten5: '#e1edfa',
  lighten6: '#f2f7fd',
};

const yellow = {
  base: '#ebb537',
  darken1: '#d69524',
  darken2: '#b57317',
  darken3: '#925217',
  darken4: '#7b4319',
  lighten1: '#eebd49',
  lighten2: '#efc86c',
  lighten3: '#f1d38e',
  lighten4: '#f7e5bb',
  lighten5: '#fbf0db',
  lighten6: '#fbf7ef',
};

export default {
  beige,
  blue,
  brown,
  dashboard,
  green,
  grey,
  orange,
  pink,
  purple,
  red,
  shades,
  slate,
  yellow,
};
